<template>
    <Slide
        title="Schedule Meeting"
        subtitle="If you’re eager to get started, feel free to schedule a meeting now using the button below"
    >
        <div class="cr:flex cr:items-center cr:justify-center">
            <div
                v-if="showSuccess"
                class="cr:mb-6 cr:bg-green-50 cr:border cr:border-green-200 cr:rounded-lg cr:p-4 cr:flex cr:items-start cr:gap-3"
            >
                <svg
                    class="cr:w-6 cr:h-6 cr:text-green-600 cr:flex-shrink-0 cr:mt-0.5"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                </svg>
                <div class="cr:flex-1">
                    <h3 class="cr:text-green-800 cr:font-semibold cr:mb-1">
                        Meeting Scheduled Successfully!
                    </h3>
                    <p class="cr:text-green-700 cr:text-sm">
                        Your meeting has been booked. You'll receive a confirmation email shortly with all the details.
                    </p>
                </div>
            </div>
            <CustomButton
                v-else
                color="origin"
                @click="handleOpenModal"
                width-class="'cr:w-fit'"
            >
                Schedule Meeting
            </CustomButton>
        </div>
    </Slide>
</template>
<script setup lang="ts">
import {useCalendly} from '@/composables/calendly';
import {useUrlParam} from '@/composables/urlParam'
import {useBase64} from '@/composables/base64'
import Slide from "@/components/slides/Slide.vue";
import CustomButton from "@/components/elements/CustomButton.vue";
import {onMounted, ref} from "vue";

const FALLBACK_MEETING_URL = 'https://calendly.com/d/cq59-wn6-5n2/fixr-demo'

const showSuccess = ref(false)

const {openCalendly} = useCalendly({
    onEventScheduled: () => {
        showSuccess.value = true
    },
    preload: true
});

const urlParam = useUrlParam()
const base64 = useBase64()

const getDemoData = () => {
    try {
        const base64Data = urlParam.get('data')

        if (base64Data) {
            const decoded = base64.decode(base64Data)
            return JSON.parse(decoded)
        }

        return null
    } catch (err) {
        console.error(err)
    }
}

const handleOpenModal = () => {
    const data = getDemoData()

    openCalendly({
        url: data?.meeting_url ?? FALLBACK_MEETING_URL,
        prefill: {
            name: data?.contact_name,
            email: data?.contact_email
        },
        utm: {
            utmSource: data?.utm_source,
            utmMedium: data?.utm_medium,
            utmCampaign: data?.utm_campaign,
        }
    });
};

onMounted(() => {
    handleOpenModal()
})
</script>